import { ICellRendererParams } from 'ag-grid-community'

import { useTrackCallback } from '@/lib/analytics/events'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

import { Hyperlink } from '@/components/lemmala-design-system/link/hyperlink'
import {
  ArtifactHyperlink,
  PublicArtifactHyperlink,
} from '@/components/shared/artifact-hyperlink/artifact-hyperlink'

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className='truncate text-body-default'>{children}</div>
)

type ArtifactLinkCellProps = ICellRendererParams<ArtifactRow> & {
  isExport?: boolean
}

export const ArtifactLinkCell = ({ data, isExport = false }: ArtifactLinkCellProps) => {
  const trackArtifactView = useTrackCallback('artifact.view')

  if (!data) return null

  const { artifact: artifactData, name, artifactSubcategory, companyId } = data
  const displayText = name || artifactSubcategory || ''

  // Handle deleted artifacts
  if (!artifactData.case) {
    return (
      <Wrapper>
        <span className='text-main-foreground-tertiary'>(Deleted) {displayText}</span>
      </Wrapper>
    )
  }

  // Return plain text for exports
  if (isExport && artifactData.case === 'artifactId') {
    return <Wrapper>{displayText}</Wrapper>
  }

  // Handle different link types
  if (artifactData.case === 'artifactId') {
    return (
      <Wrapper>
        {companyId ? (
          <ArtifactHyperlink artifactId={artifactData.value}>{displayText}</ArtifactHyperlink>
        ) : (
          <PublicArtifactHyperlink artifactId={artifactData.value}>
            {displayText}
          </PublicArtifactHyperlink>
        )}
      </Wrapper>
    )
  }

  // Regular hyperlink for non-artifact URLs
  return (
    <Wrapper>
      <Hyperlink
        onClick={() => trackArtifactView({ artifactLink: artifactData.value })}
        href={artifactData.value}
      >
        {displayText}
      </Hyperlink>
    </Wrapper>
  )
}
